var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#C9CFE4",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6617_11959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40381 5.83274L7.58579 9.01472L4.40381 12.1967C4.20847 12.392 4.20847 12.7085 4.40381 12.9038L5.11091 13.6109C5.30625 13.8063 5.62268 13.8063 5.81802 13.6109L9 10.4289L12.182 13.6109C12.3773 13.8063 12.6937 13.8063 12.8891 13.6109L13.5962 12.9038C13.7915 12.7085 13.7915 12.392 13.5962 12.1967L10.4142 9.01472L13.5962 5.83274C13.7915 5.6374 13.7915 5.32097 13.5962 5.12563L12.8891 4.41852C12.6937 4.22319 12.3773 4.22319 12.182 4.41852L9 7.60051L5.81802 4.41852C5.62268 4.22319 5.30625 4.22319 5.11091 4.41852L4.40381 5.12563C4.20847 5.32097 4.20847 5.6374 4.40381 5.83274Z",
    fill: "#101527"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6617_11959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.c6e76dfaa12a078c4de3b009068e60e5.svg";
export { ForwardRef as ReactComponent };